import { Text, Spacer } from "@hackthenorth/north";
import { Link } from "north.js";
import React from "react";
import { Navigate } from "react-router-dom";
import styled from "styled-components";

import { PageWrapper } from "src/shared/components";
import { Route } from "src/shared/constants/route";
import { Permission, usePermissionsContext } from "src/shared/contexts";
import { Field } from "src/shared/contexts/HackerContext/types";
import { useHackerState } from "src/shared/contexts/HackerContext/useHackerState";
import { useRsvpFlow } from "src/shared/hooks";

import { BusForm } from "./busForm";
import { FlightForm } from "./flightForm";

const StyledPageWrapper = styled(PageWrapper)`
  @media (max-width: 768px) {
    width: 100%;
    padding-left: 24px;
  }
  @media (min-width: 769px) {
    width: 70%;
    padding-left: 60px;
  }
`;

const HeaderText = styled.h1`
  font-size: 28px;
  font-weight: 900;
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.heading};
  line-height: 1.5;
  color: ${({ theme }) => theme.globalConstants.color.brandSecondary};
  margin-bottom: 8px;
  margin-top: 0;
`;

const TravelForm = () => {
  const ISFLIGHTCLOSED = false;
  const ISBUSCLOSED = false;

  const ACCEPTED_FIELDS = [Field.TRAVEL_OPTION];

  const { responsesState } = useHackerState(ACCEPTED_FIELDS, {});
  const { isHacker } = useRsvpFlow();
  const { hasPermission } = usePermissionsContext();
  const isFlight = responsesState[Field.TRAVEL_OPTION] === "flight";
  const isReadOnly = !hasPermission(Permission.TRAVEL_PLAN_FORM);

  const Title = () => <HeaderText>Travel details</HeaderText>;

  const travelEmail = (
    <Link href="mailto:travel@hackthenorth.com">
      <span style={{ fontWeight: "bold" }}>travel@hackthenorth.com</span>
    </Link>
  );

  const Description = () =>
    isReadOnly ? (
      <Text>
        Your travel plan is now read-only. Review your submitted travel details
        below. To request a change, contact {travelEmail}.
      </Text>
    ) : isFlight ? (
      <Text>
        Enter your flight and reimbursement details below. If your selected
        travel method is incorrect, go back and edit your RSVP submission. If
        you need help changing it, contact {travelEmail}.
      </Text>
    ) : (
      <Text>
        Please select the bus route that is most convenient for you. You will
        receive a confirmation email once you&apos;ve confirmed the route. If
        your selected travel method is incorrect, go back and edit your RSVP
        submission. If you need help changing it or have questions about buses,
        contact {travelEmail}.
      </Text>
    );

  if (!isHacker) {
    return <Navigate to={Route.HACKER_RSVP} replace />;
  }

  const Form = () =>
    isFlight ? (
      <FlightForm isFlightClosed={ISFLIGHTCLOSED} isReadOnly={isReadOnly} />
    ) : (
      <BusForm isBusClosed={ISBUSCLOSED} isReadOnly={isReadOnly} />
    );

  return (
    <StyledPageWrapper>
      {!ISFLIGHTCLOSED && <Title />}
      <Spacer height={16} />
      {!ISFLIGHTCLOSED && <Description />}
      <Spacer height={42} />
      <Form />
    </StyledPageWrapper>
  );
};

export default React.memo(TravelForm);
